import styleInject from '../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".RadioGroup-module_radioGroup__2lRhW {\n  display: flex;\n}\n.RadioGroup-module_radioGroup__2lRhW *:not(:first-child) {\n  margin-right: 32px;\n}";
var styles = {"radioGroup":"RadioGroup-module_radioGroup__2lRhW"};
styleInject(css_248z);

export { styles as default };
